@if (open && sale) {
  <div class="sd-backdrop" (click)="onBackdropClick($event)" aria-hidden="true"></div>

  <div class="sd-panel" role="dialog" aria-modal="true" aria-labelledby="sd-title">
    <!-- Header -->
    <div class="sd-head">
      <div class="min-w-0">
        <h2 id="sd-title" class="sd-title">Venta a {{ sale.clientName || 'cliente genérico' }}</h2>
        <p class="sd-subtitle">{{ formatDate(sale.createdAt) }}</p>
      </div>
      <button #closeBtn type="button" (click)="close()" class="sd-icon-btn" aria-label="Cerrar detalle">
        <svg class="size-5" fill="none" viewBox="0 0 24 24" stroke-width="1.75" stroke="currentColor" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Body -->
    <div class="sd-body">
      <div class="sd-receipt">
        <div class="sd-receipt__top">
          <span class="sd-status" [attr.data-status]="sale.status">{{ getStatusInfo(sale.status).label }}</span>
          <p class="sd-total">{{ formatCurrency(sale.amount) }}</p>
          <p class="sd-total__hint">{{ itemsCount }} unidad{{ itemsCount !== 1 ? 'es' : '' }}</p>
        </div>

        <ul class="sd-lines" aria-label="Productos vendidos">
          @for (item of sale.items; track $index) {
            <li class="sd-line">
              <span class="sd-line__name">
                {{ item.itemName || item.itemType }}
                <span class="sd-line__qty">{{ item.quantity }} × {{ formatCurrency(item.unitPrice) }}</span>
              </span>
              <span class="sd-line__leader" aria-hidden="true"></span>
              <span class="sd-line__amount">{{ formatCurrency(item.total) }}</span>
            </li>
          }
        </ul>

        <dl class="sd-sum">
          <div class="sd-sum__row">
            <dt>Total</dt>
            <dd>{{ formatCurrency(sale.amount) }}</dd>
          </div>
          <div class="sd-sum__row">
            <dt>Pagado{{ sale.paidAmount > 0 ? ' en ' + (getMethodInfo(sale.paymentMethod).label | lowercase) : '' }}</dt>
            <dd>{{ formatCurrency(sale.paidAmount) }}</dd>
          </div>
          @if (pendingAmount > 0) {
            <div class="sd-sum__row sd-sum__row--due">
              <dt>Por cobrar</dt>
              <dd>{{ formatCurrency(pendingAmount) }}</dd>
            </div>
          }
        </dl>
      </div>

      @if (hasClientProfile) {
        <a [routerLink]="['/people', sale.clientId]" class="sd-client">
          <span class="sd-client__avatar" aria-hidden="true">{{ initials }}</span>
          <span class="min-w-0 flex-1">
            <span class="sd-client__name">{{ sale.clientName || 'Cliente genérico' }}</span>
            <span class="sd-client__hint">Ver ficha del cliente</span>
          </span>
          <svg class="size-4 shrink-0" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
          </svg>
        </a>
      }

      @if (sale.paymentId) {
        <p class="sd-note">
          El comprobante no es un documento fiscal. Se descarga en media carta, para imprimir dos por hoja.
          Si usas impresora térmica,
          <button type="button" class="sd-inline-link" (click)="onDownloadReceipt('ticket')" [disabled]="isDownloading">descárgalo en tirilla de 80 mm</button>.
        </p>
      }
    </div>

    <!-- Footer -->
    <div class="sd-foot">
      <button type="button" (click)="close()" class="sd-btn sd-btn--ghost">Cerrar</button>
      @if (sale.paymentId) {
        <button type="button" (click)="onDownloadReceipt()" [disabled]="isDownloading"
          class="sd-btn sd-btn--primary inline-flex flex-1 items-center justify-center gap-2" [attr.aria-busy]="isDownloading">
          @if (isDownloading) {
            <span class="sd-spinner" aria-hidden="true"></span>
            Generando comprobante…
          } @else {
            <svg class="size-4" fill="none" viewBox="0 0 24 24" stroke-width="1.75" stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
            </svg>
            Descargar comprobante
          }
        </button>
      }
    </div>
  </div>
}
